import { useState, useCallback, useRef, type ReactNode } from 'react';

type ToastState = {
  isVisible: boolean;
  message: ReactNode;
  key: number;
};

export const useToast = () => {
  const [toast, setToast] = useState<ToastState>({
    isVisible: false,
    message: '',
    key: 0,
  });

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showToast = useCallback((message: ReactNode) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setToast((prev) => {
      if (prev.isVisible) {
        timeoutRef.current = setTimeout(() => {
          setToast({ isVisible: true, message, key: Date.now() });
        }, 100);
        return { ...prev, isVisible: false };
      }
      return { isVisible: true, message, key: Date.now() };
    });
  }, []);

  const hideToast = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setToast((prev) => ({ ...prev, isVisible: false }));
  }, []);

  return {
    toast,
    showToast,
    hideToast,
  };
};
